import Vue from "vue";
import Router from "vue-router";

import firebase from "firebase/app";
import "firebase/auth";

Vue.use(Router);

const router = new Router({
  mode: process.env.CORDOVA_PLATFORM ? "hash" : "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        {
          path: "/",
          redirect: "/dashboard/"
        },
        {
          path: "/dashboard/",
          name: "dashboardAnalytics",
          component: () => import("./views/DashboardAnalytics.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/trends",
          name: "trendAnalytics",
          component: () => import("@/components/trends/trends.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Trend Data", active: true }
            ],
            pageTitle: "Analytics Trend",
            rule: "editor"
          }
        },
        {
          path: "/dimmingPolicy",
          name: "dimmingPolicy",
          component: () =>
            import("@/components/dimmingPolicy/dimmingPolicy.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Dimming Policy", active: true }
            ],
            pageTitle: "Dimming Schedule Configuration",
            rule: "editor"
          }
        },
        // {
        //   path: "/dimmingPolicy",
        //   name: "dimmingPolicy",
        //   component: () =>
        //     import("@/components/dimmingPolicy/dimmingPolicy.vue"),
        //   meta: {
        //     breadcrumb: [
        //       { title: "Home", url: "/" },
        //       { title: "Schedule Policy", active: true }
        //     ],
        //     pageTitle: " Schedule Configuration",
        //     rule: "editor"
        //   }
        // },
        {
          path: "/modemMapView",
          name: "modemMapView",
          component: () => import("@/components/viewModems/GoogleMap.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "View SmartLinks", active: true }
            ],
            pageTitle: "SmartLink Map View",
            rule: "editor"
          }
        },
        {
          path: "/surveillux",
          name: "surveillux",
          component: () => import("@/components/survillux/surveillux.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "View Live Feed", active: true }
            ],
            pageTitle: "Lights With Hidden Camera Feed",
            rule: "editor"
          }
        },
        {
          path: "/masterView",
          name: "masterView",
          component: () =>
            import("@/components/masterMapView/masterMapView.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Master View", active: true }
            ],
            pageTitle: "Master View",
            rule: "editor"
          }
        },
        {
          path: "/zones",
          name: "zonesView",
          component: () => import("@/components/zones/zones.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Zones", active: true }
            ],
            pageTitle: "Zone Management",
            rule: "editor"
          }
        },
        {
          path: "/locations",
          name: "locationsView",
          component: () => import("@/components/locations/locations.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Locations", active: true }
            ],
            pageTitle: "Location Management",
            rule: "editor"
          }
        },
        {
          path: "/modems",
          name: "modemView",
          component: () => import("@/components/modems/modems.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "SmartLinks", active: true }
            ],
            pageTitle: "SmartLink Management",
            rule: "editor"
          }
        },
        {
          path: "/masterReports/energyConsumption",
          name: "energyConsumption",
          component: () => import("@/components/reports/energyConsumption.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Master Reports", active: true }
            ],
            pageTitle: "Energy Consumption",
            rule: "editor"
          }
        },
        {
          path: "/modemReports/modemStatus",
          name: "modemStatus",
          component: () => import("@/components/reports/modemStatus.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Modem Reports", active: true }
            ],
            pageTitle: "Modem Status",
            rule: "editor"
          }
        },
        {
          path: "/monirtoring/dataMonitoring",
          name: "dataMonitoring",
          component: () => import("@/components/monitoring/dataMonitoring.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Monitoring", active: true }
            ],
            pageTitle: "Data Monitoring",
            rule: "editor"
          }
        },
        {
          path: "/monirtoring/faultMonitoring",
          name: "faultMonitoring",
          component: () =>
            import("@/components/monitoring/faultMonitoring.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Monitoring", active: true }
            ],
            pageTitle: "Fault Monitoring",
            rule: "editor"
          }
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/views/pages/Profile.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Pages" },
              { title: "Profile", active: true }
            ],
            pageTitle: "Profile",
            rule: "editor"
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/callback",
          name: "authCallback",
          component: () => import("@/views/Callback.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/login",
          name: "pageLogin",
          component: () => import("@/views/pages/Login.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/register",
          name: "pageRegister",
          component: () => import("@/views/pages/Register.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/forgot-password",
          name: "pageForgotPassword",
          component: () => import("@/views/pages/ForgotPassword.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/reset-password",
          name: "pageResetPassword",
          component: () => import("@/views/pages/ResetPassword.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/lock-screen",
          name: "pageLockScreen",
          component: () => import("@/views/pages/LockScreen.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/comingsoon",
          name: "pageComingSoon",
          component: () => import("@/views/pages/ComingSoon.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/error-404",
          name: "pageError404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/error-500",
          name: "pageError500",
          component: () => import("@/views/pages/Error500.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/not-authorized",
          name: "pageNotAuthorized",
          component: () => import("@/views/pages/NotAuthorized.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/maintenance",
          name: "pageMaintenance",
          component: () => import("@/views/pages/Maintenance.vue"),
          meta: {
            rule: "editor"
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {
    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser;
    if (
      to.path === "/pages/login" ||
      to.path === "/pages/forgot-password" ||
      to.path === "/pages/error-404" ||
      to.path === "/pages/error-500" ||
      to.path === "/pages/register" ||
      to.path === "/callback" ||
      to.path === "/pages/comingsoon" ||
      firebaseCurrentUser
    ) {
      return next();
    }
    router.push({ path: "/pages/login", query: { to: to.path } });
    // Specify the current path as the customState parameter, meaning it
    // will be returned to the application after auth
    // auth.login({ target: to.path });
  });
});
export default router;
